export default __webpack_public_path__ + "static/media/ecran_1_je_decide_FR.4a6362a0.png";